import Flickity from "flickity";

class Reviews {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.autoPlay = self.elem.getAttribute('data-autoplay') === 'true';
    }

    init() {
        let self = this;

        const flkty = new Flickity(self.elem, {
            autoPlay: self.autoPlay === true ? 7000 : false,
            cellAlign: 'left',
            groupCells: true,
            prevNextButtons: false,
            wrapAround: true,
        });
    }
}

export default Reviews;
